import React from 'react';
import { Section } from '@radix-ui/themes';

import PageTitle from 'components/layout/PageTitle';
import BoardDetail from 'components/board/BoardDetail';

// 게시판 관리 > 주요결과 관리 > 상세
export default function ResultDetail() {
  const boardType = 'result';

  return (
    <Section>
      <PageTitle title="주요결과 상세" />
      <BoardDetail boardType={boardType} />
    </Section>
  );
}
